import { useEffect } from 'react'

import { DarkModeToggle as CoreDarkModeToggle } from '@writefull/core'

import useSettingsStore from '@infrastructure/stores/settings/settings-store'

export default function DarkModeToggle() {
  const darkMode = useSettingsStore.use.darkMode()
  const setDarkMode = useSettingsStore.use.setDarkMode()

  const toggleDarkMode = () => {
    setDarkMode(!darkMode)
  }

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [darkMode])

  return (
    <CoreDarkModeToggle
      checked={darkMode}
      onChange={toggleDarkMode}
      className='[--bg-checked:#1d293d] theme-transition'
    />
  )
}
